export const apiConstants = {
  url: "/api/udtable",
  udvalue: "/api/udvalue"
};
